import { authRoutes } from "./apiRoutes/auth.routes";
import { ayudasRoutes } from "./apiRoutes/ayudas.routes";
import { dashboardRoutes } from "./apiRoutes/dashboard.routes";
import { documentsRoutes } from "./apiRoutes/documents.routes";
import { empresaSedeHomologacionRoutes } from "./apiRoutes/empresaSedeHomologacion.routes";
import { indicadorGobRoutes } from "./apiRoutes/indicadorGob.routes";
import { miscRoutes } from "./apiRoutes/misc.routes";
import { paiRoutes } from "./apiRoutes/pai.routes";
import { citologiaRoutes } from "./apiRoutes/citologia.routes";
import { patientsRoutes } from "./apiRoutes/patients.routes";
import { planPartoRoutes } from "./apiRoutes/planParto.routes";
import { calculadorasDinamicasRoutes } from "./apiRoutes/calculadorasDinamicas.routes";
import { routesPymRoutes } from "./apiRoutes/routesPym.routes";
import { soportePreguntasReportesRoutes } from "./apiRoutes/soportePreguntasReportes.routes";
import { usersRoutes } from "./apiRoutes/users.routes";
import { logServicesRoutes } from "./apiRoutes/logServices.routes";
import { enlacesRoutes } from "./apiRoutes/enlaces.routes";
import { patientPortalRoutes } from "./apiRoutes/patientPortal.routes";
import { mastersRoutes } from "./apiRoutes/masters.routes";

const rawBase = process.env.REACT_APP_BASE_URL || "http://localhost:8000";
const rawApi = process.env.REACT_APP_API || "apiAPIM";

const BASE_URL = String(rawBase).replace(/\/+$/, "");
const API = String(rawApi === "undefined" ? "apiAPIM" : rawApi).replace(/^\/+|\/+$/g, "");
const apiBase = `${BASE_URL}/${API}`;

export const API_ROUTES = {
  ...authRoutes(apiBase),
  ...paiRoutes(apiBase),
  ...citologiaRoutes(apiBase),
  ...patientsRoutes(apiBase),
  ...documentsRoutes(apiBase),
  ...routesPymRoutes(apiBase),
  ...usersRoutes(apiBase),
  ...dashboardRoutes(apiBase),
  ...planPartoRoutes(apiBase),
  ...calculadorasDinamicasRoutes(apiBase),
  ...empresaSedeHomologacionRoutes(apiBase),
  ...soportePreguntasReportesRoutes(apiBase),
  ...ayudasRoutes(apiBase),
  ...indicadorGobRoutes(apiBase),
  ...logServicesRoutes(apiBase),
  ...miscRoutes(apiBase),
  ...enlacesRoutes(apiBase),
  ...patientPortalRoutes(apiBase),
  ...mastersRoutes(apiBase),
};

